// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1AGGX","amount":"Amount_amount__-E0BA","tip":"Amount_tip__2rojg","tipHeader":"Amount_tipHeader__1erc8","tipsWrap":"Amount_tipsWrap__1OrBu"};